import axios from 'axios';

export const getRoleByWorkspaceId = async (workspaceId: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_COMMENT_STREAM_BACKEND_URL}/api/v1/workspace-member/workspace-id`,
      {
        params: { workspace_id: workspaceId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('idToken')}`,
          'ngrok-skip-browser-warning': 'true',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error fetching workspace name:', error);
  }
};
